<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo">
                <dados-relatorios-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">
                <vk-tabs-vertical keep-alive>

                    <vk-tabs-item title="COMANDO LIVRE" >
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS">
                        <tempos-bws :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP">
                        <IpBws :config="config"/>
                    </vk-tabs-item>

                </vk-tabs-vertical>

            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>
<script>
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import Tempos from './partials/concox/Tempos';
    import Apn from './partials/concox/Apn';
    import Ip from './partials/concox/Ip';
    import Filtro from './partials/concox/Filtro';
    import HeaderAdmin from './HeaderAdmin';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import HabilitarAlertaTransmissao from "../buttons/HabilitarAlertaTransmissao";
    import MapPosicao from "./partials/MapPosicao.vue";
    import PosicaoAtual from "./partials/PosicaoAtual.vue";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import Problemas from '../veiculo/Problemas';
    import GoogleMapsButton from "../buttons/GoogleMapsButton.vue";
    import GoogleEarthButton from "../buttons/GoogleEarthButton.vue";
    import PositionsMaps from './partials/PositionsMaps.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import TemposBws from './partials/bws/Tempos.vue';
    import { BWS } from '../../class/bws';
    import IpBws from './partials/bws/IpBws.vue';
    import ComandoLivre from './partials/generico/ComandoLivre.vue';

    export default {
        name: 'BwsE3',

        components: {
            ComandoLivre,
            IpBws,
            TemposBws,
            DadosRelatoriosAdmin,
            DadosDoVeiculoAdmin,
            DadosDoClienteAdmin,
            PositionsMaps,
            GoogleEarthButton,
            GoogleMapsButton,
            Problemas,
            HabilitarAlertaTransmissao,
            EnviarSaidas, HeaderAdmin,
            PosicaoAtual, MapPosicao, TableComandos, Reset,
            SolicitarConfiguracao, Tempos, Apn, Ip, Filtro
        },

        mixins: [
            veiculosAdminMixins
        ],

        data(){
            return {
                config: null,
            }
        },
        async beforeMount(){
            this.config = await BWS.byPK(this.rastreador.id_rastreador);
        },
    }
</script>
